export async function validateLocationByClientRelocationsUseCase(client_id, identifier, identifier_type, relocationRepository) {
    const result = await relocationRepository.validate_location_by_client(client_id, identifier, identifier_type);
    
    return result;
}